import {clsx} from 'clsx'
import type {ComponentPropsWithoutRef} from 'react'

import styles from './styled-group-header.module.css'

export const GROUP_HEADER_HEIGHT = 44

type StyledGroupHeaderProps = ComponentPropsWithoutRef<'div'> & {topOffset?: number; ref?: React.Ref<HTMLDivElement>}

export const StyledGroupHeader = ({ref, topOffset, style, children, className, ...props}: StyledGroupHeaderProps) => {
  return (
    <div
      ref={ref}
      style={{top: topOffset ?? 0, height: `${GROUP_HEADER_HEIGHT}px`, ...style}}
      className={clsx(styles.styledGroupHeaderWrapper, className)}
      {...props}
    >
      {children}
    </div>
  )
}

StyledGroupHeader.displayName = 'StyledGroupHeader'
